import { useEffect } from 'react';
import '../css/MemberTheme.css';
import '../css/MemberLightTheme.css';

const paths = {
  court: 'M3 4h18v16H3zM3 12h18M12 4v16M3 8h18M3 16h18M6 4v16M18 4v16',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  scan: 'M8 3H3v5M16 3h5v5M3 16v5h5M21 16v5h-5M7 12h10M8 8h8M8 16h8',
  gift: 'M3 8h18v4H3zM5 12v9h14v-9M12 8v13M12 8H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z',
  profile: 'M4 21v-2a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v2',
  refresh: 'M20 7a8 8 0 1 0 1 9M20 3v5h-5', clock: 'M12 7v5l3 2',
  target: 'M21 12a9 9 0 1 1-9-9M12 12l9-9M16 3h5v5',
  star: 'm12 3 3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1Z',
  history: 'M6 3h12v18H6zM9 8h6M9 12h6M9 16h4',
  trophy: 'M8 3h8v7a4 4 0 0 1-8 0V3ZM8 5H4v3a4 4 0 0 0 4 4M16 5h4v3a4 4 0 0 1-4 4M12 14v7M8 21h8',
  arrow: 'M19 12H5m6-6-6 6 6 6', check: 'm5 12 4 4L19 6', close: 'm6 6 12 12M18 6 6 18',
  camera: 'M3 6h5l2-3h4l2 3h5v15H3z', edit: 'm16 3 5 5-12 12-6 1 1-6L16 3ZM13 6l5 5',
  logout: 'M9 3H3v18h6M9 12h12m-5-5 5 5-5 5', info: 'M12 11v6M12 7h.01',
  calendar: 'M3 5h18v16H3zM7 2v6M17 2v6M3 10h18',
  points: 'M3 6c0-5 18-5 18 0s-18 5-18 0Zm0 0v6c0 5 18 5 18 0V6M3 12v6c0 5 18 5 18 0v-6',
  bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4'
};
export function MemberIcon({ name = 'court', size = 22, ...props }) {
  return <svg className="nm-icon" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...props}>
    {['profile', 'users'].includes(name) && <circle cx={name === 'users' ? 9 : 12} cy="7" r="4" />}
    {['clock', 'info'].includes(name) && <circle cx="12" cy="12" r="9" />}
    {name === 'camera' && <circle cx="12" cy="13" r="4" />}
    <path d={paths[name] || paths.court} />
  </svg>;
}
export function useMemberTheme(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    document.body.classList.add('namad-member');
    // Temporarily keep every member-facing page on the proven dark theme.
    // Keep the stored preference untouched so light mode can return later.
    document.body.dataset.memberTheme = 'dark';
    return () => document.body.classList.remove('namad-member');
  }, [enabled]);
}
export function memberTemplateClass(page, className = '') {
  return `namad-page nm-template nm-template-${page} ${className}`.trim();
}
export function MemberPage({ page, as: Component = 'main', className = '', children, ...props }) {
  return <Component className={memberTemplateClass(page, className)} data-member-page={page} {...props}>
    {children}
  </Component>;
}
export function MemberBrand({ children }) {
  return <div className="nm-brand-row"><a className="nm-brand" href="/monitor" aria-label="NAMAD Badminton ดูคิวสนาม"><img src="/namad-logo12.png" alt="" /><span><b>NAMAD</b><small>BADMINTON</small></span></a>{children}</div>;
}
export function MemberCard({ as: Component = 'section', className = '', children, ...props }) {
  return <Component className={`nm-card ${className}`} {...props}>{children}</Component>;
}
export function MemberBadge({ tone = 'neutral', children, ...props }) {
  return <span className={`nm-badge nm-badge-${tone}`} {...props}>{children}</span>;
}
export function MemberButton({ busy, children, variant = 'primary', ...props }) {
  return <button type="button" {...props} className={`nm-button nm-button-${variant} ${props.className || ''}`} disabled={props.disabled || busy} aria-busy={busy || undefined}>{busy ? 'กำลังดำเนินการ…' : children}</button>;
}
